import { GET_LANGUAGES_START, GET_LANGUAGES_SUCCESS, RESET_STORE } from "./types";

const initialState = {
  loading: false,
  results: [],
};

export default (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
  case GET_LANGUAGES_START:
    return {
      ...state,
      results: [],
      loading: true,
    };
  case GET_LANGUAGES_SUCCESS:
    return {
      ...state,
      results: payload.results,
      loading: false,
    };
  case RESET_STORE:
    return initialState;
  default:
    return state;
  }
};
